/* ### BASE URL ### */
import { StringUtils } from '../core-frontend-common/utils/string-utils';
import { PRODUCTION_BUILD, SYSTEM_NAME, PROD_BUILD_USE_HTTPS, DEV_BUILD_USE_HTTPS, DEVAPI_BUILD, LOCAL_BACKEND, LOCAL_AUTH } from './app.settings';
import {
  SYSTEM_NAME_ALFRED,
  SYSTEM_NAME_EPC,
  SYSTEM_NAME_AUTH,
  SYSTEM_NAME_ETD, SYSTEM_NAME_HELPDESK,
  SYSTEM_NAME_ISBN,
  SYSTEM_NAME_LIBADMIN, SYSTEM_NAME_ORIGINALITY,
  SYSTEM_NAME_ROOMBOOK, SYSTEM_NAME_TOOLS, SYSTEM_NAME_UIK,
  SYSTEM_NAME_ZP,
} from './constants';

function getApiProtocol(): string {
  if (PRODUCTION_BUILD) {
      if (PROD_BUILD_USE_HTTPS) {
          return 'https';
      } else {
          return 'https';
      }
  }

  if (DEVAPI_BUILD) {
      if (DEV_BUILD_USE_HTTPS) {
          return 'https';
      } else {
          return 'https';
      }
  }

  return 'https';
}

function getClientProtocol(): string {
  if (PRODUCTION_BUILD) {
      if (PROD_BUILD_USE_HTTPS) {
          return 'https';
      } else {
          return 'https';
      }
  }

  if (DEVAPI_BUILD) {
      if (DEV_BUILD_USE_HTTPS) {
          return 'https';
      } else {
          return 'https';
      }
  }

  return 'https';
}

export const LOCAL_APP_PORTS = {
  [SYSTEM_NAME_EPC]: 0,
  [SYSTEM_NAME_ETD]: 3003,
  [SYSTEM_NAME_ISBN]: 3004,
  [SYSTEM_NAME_ROOMBOOK]: 3001,
  [SYSTEM_NAME_ZP]: 0,
  [SYSTEM_NAME_UIK]: 3002,
  [SYSTEM_NAME_HELPDESK]: 0,
  [SYSTEM_NAME_TOOLS]: 0,
  [SYSTEM_NAME_LIBADMIN]: 0,
  [SYSTEM_NAME_ALFRED]: 3003
};

export const LOCAL_HOST = 'localhost';         // local frontend host (default localhost)
export const LOCAL_FRONTEND_PORT = '3003';     // local frontend port
export const LOCAL_BACKEND_PORT = '63550';     // local API port

export const PROD_HOST = 'portal.tuke.sk';         // production hostname
export const PROD_HOST_PORT = '';                      // production host port (empty for default)
export const PROD_API_HOST = 'portal.tuke.sk';        // production API hostname
export const PROD_API_HOST_PORT = '';                  // production API host port (empty for default)
export const DEV_HOST = 'portal.dev.msweb.tuke.sk';      // development hostname
export const DEV_HOST_PORT = '';                       // development host port (empty for default)
export const DEV_API_HOST = 'portal.dev.msweb.tuke.sk';     // development API hostname
export const DEV_API_HOST_PORT = '';                      // development API host port (empty for default)

// local addresses (used for local development)
export const LOCAL_FRONTEND_URL = `${getClientProtocol()}://${LOCAL_HOST}:${LOCAL_FRONTEND_PORT}`;
const LOCAL_API_URL = `${getApiProtocol()}://${LOCAL_HOST}:${LOCAL_BACKEND_PORT}/api`;

// base URL for frontend (non-local)
export const BASE_FRONTEND_URL = `${getClientProtocol()}://${PRODUCTION_BUILD ?
    (PROD_HOST + (StringUtils.isNullOrEmpty(PROD_HOST_PORT) ? '' : (':' + PROD_HOST_PORT))) :
    (DEV_HOST + (StringUtils.isNullOrEmpty(DEV_HOST_PORT) ? '' : (':' + DEV_HOST_PORT)))}`;

const ORIGINALITY_BASE_URL = getBaseApiUrl(SYSTEM_NAME_ORIGINALITY);
const ALFRED_BASE_URL = getBaseApiUrl(SYSTEM_NAME_ALFRED);
const EPC_BASE_URL = getBaseApiUrl(SYSTEM_NAME_EPC);

export const LIBADMIN_URL = getBaseApiUrl(SYSTEM_NAME_LIBADMIN);

// constructs base URL for API
export function getBaseApiUrl(systemName?: string): string {
  if (PRODUCTION_BUILD) {
    return `${getApiProtocol()}://api.${systemName}.${PROD_API_HOST}${
      StringUtils.isNullOrEmpty(PROD_API_HOST_PORT) ? '' : (':' + PROD_API_HOST_PORT)
    }/api`;
  } else if (LOCAL_BACKEND && !DEVAPI_BUILD) {
    return LOCAL_API_URL;
  }

  return `${getApiProtocol()}://api.${systemName}.${DEV_API_HOST}${
    StringUtils.isNullOrEmpty(DEV_API_HOST_PORT) ? '' : (':' + DEV_API_HOST_PORT)
  }/api`;
}

export function getBaseFrontendUrl(systemName?: string): string {
  if (systemName === SYSTEM_NAME_AUTH) {
    return `${getClientProtocol()}://${PRODUCTION_BUILD ? PROD_HOST : DEV_HOST}${
      StringUtils.isNullOrEmpty(PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT) ? '' : (':' + (PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT))
    }`;
  }
  return `${getClientProtocol()}://${systemName}.${PRODUCTION_BUILD ? PROD_HOST : DEV_HOST}${
    StringUtils.isNullOrEmpty(PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT) ? '' : (':' + (PRODUCTION_BUILD ? PROD_HOST_PORT : DEV_HOST_PORT))
  }`;
}

// constructs base URL for API host without suffix
function getCurrentApiHost(): string {
    if (PRODUCTION_BUILD) {
        return `${getApiProtocol()}://${PROD_API_HOST}`;
    } else if (LOCAL_BACKEND) {
        return `${getApiProtocol()}://${LOCAL_HOST}:${LOCAL_BACKEND_PORT}`;
    }

    return `${getApiProtocol()}://${DEV_API_HOST}`;
}

export const BASE_URL = getBaseApiUrl(SYSTEM_NAME);
export const ADMIN_URL = getBaseApiUrl(SYSTEM_NAME_LIBADMIN);
export const CURRENT_API_HOST_URL = getCurrentApiHost();

const API_FACULTY_CODEBOOK = '/codebook/getFaculties';
const API_DEPARTMENT_CODEBOOK = '/codebook/getDepartments/';

export function getAppConfigurationUrl() {
  return `${BASE_URL}/config/client`;
}

export function getSearchCollateFieldOfStudyUrl(phrase) {
  return `${BASE_URL}/codebook/searchCollateFieldOfStudy/${phrase}`;
}

export function getLanguagesUrl() {
  return `${BASE_URL}/codebook/getLanguages`;
}

/* ### USER URLS ### */
const API_GET_USER = '/user';
const API_GET_USER_HISTORICAL = '/user/getWithHistorical/';
const API_GET_USER_PHOTO = '/user/photo/';
const API_GET_SEARCHED_USER = '/user/getSearched';
const API_UPDATE_EXTERNAL_USER = '/user/updateExternalThesisUser/';
const API_SEARCH_USER_COLLATE = '/user/searchCollate/';

export function getFacultyCodebookUrl() {
  return BASE_URL + API_FACULTY_CODEBOOK;
}

export function getDepartmentCodebookUrl(facultyId) {
  return `${BASE_URL + API_DEPARTMENT_CODEBOOK}/${facultyId}`;
}

export function getHistoricalUserByIdUrl(id: number) {
  return BASE_URL + API_GET_USER_HISTORICAL + id;
}

export function getUserPhotoUrl(hash: string) {
  return BASE_URL + API_GET_USER_PHOTO + hash;
}

export function getSearchedUserUrl() {
  return BASE_URL + API_GET_SEARCHED_USER;
}

export function getUpdateExternalUserUrl(id) {
  return BASE_URL + API_UPDATE_EXTERNAL_USER + id;
}

export function getSearchUserCollateUrl(phrase) {
  return BASE_URL + API_SEARCH_USER_COLLATE + phrase;
}

export function getAllFaqsUrl() {
  return `${BASE_URL}/faq/getAllFaq`;
}

export function getFaqBySystemUrl(systemName: string) {
  return `${BASE_URL}/faq/getFaqBySystem/${systemName}`;
}

export function getCreateFaqUrl() {
  return `${BASE_URL}/faq/AddFaq`;
}

export function getUpdateFaqUrl(id: number) {
  return `${BASE_URL}/faq/updateFaq/${id}`;
}

export function getDeleteFaqUrl(id: number) {
  return `${BASE_URL}/faq/deleteFaq/${id}`;
}

export function generatePromoCodesOriginalityUrl(count: number) {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/create/cash/${count}`;
}

export function generatePromoCodesForUsersUrl() {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/create/bulk/private/email`;
}

export function generatePromoCodesForUsersByFilterUrl() {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/create/bulk/private/filter`;
}

export function generatePromoCodesForSchoolsUrl() {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/create/public`;
}

export function getThesisOrderStatusUrl(orderId: number) {
  return `${ORIGINALITY_BASE_URL}/thesisOrder/anonymous/getStatusByOrderId/${orderId}`;
}

export function getThesisOrderSendProtocolUrl() {
  return `${ORIGINALITY_BASE_URL}/thesisOrder/send/protocol`;
}

export function getThesisOrderByFilterUrl() {
  return `${ORIGINALITY_BASE_URL}/thesisOrder/admin/getAllByFilter`;
}

export function getAllPromocodesByFilterUrl() {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/getAllByFilter`;
}

export function getAllThesisOrdersByFilterUrl() {
  return `${ORIGINALITY_BASE_URL}/admin/getAllByFilter`;
}

export function getDeletePromocodeUrl(id: number) {
  return `${ORIGINALITY_BASE_URL}/admin/promoCode/delete/${id}`;
}

export function addNotificationUrl() {
  return `${BASE_URL}/notification/create`;
}

export function updateNotificationUrl(id: number) {
  return `${BASE_URL}/notification/update/${id}`;
}

export function getNotificationUrl(filter: string) {
  return `${BASE_URL}/notification?${filter}`;
}

export function getNotificationDeleteUrl(id: number) {
  return `${BASE_URL}/notification/delete/${id}`;
}

export function getSessionValidityCheckUrl() {
  return `${BASE_URL}/auth/validSession`;
}

export function getAllNotificationsForSystem(isForLoginScreen: boolean, systemName: string) {
  return LIBADMIN_URL + '/notification?isForLoginScreen=' + isForLoginScreen + '&application=' + systemName;
}

export function getEpcAllProjectsUrl() {
  return `${EPC_BASE_URL}/project/admin/getAllByFilter`;
}

export function getEpcProjectCreateUrl() {
  return `${EPC_BASE_URL}/project/admin/create`;
}

export function getEpcProjectUpdateUrl() {
  return `${EPC_BASE_URL}/project/admin/update`;
}

export function getEpcProjectDeleteUrl(id: number) {
  return `${EPC_BASE_URL}/project/admin/delete/${id}`;
}
